<template>
    <v-container
        class="grey lighten-4 pa-10"
        style="max-width: 680px;"
    >
        <p class="text-left text-subtitle greeting-text">
            Greetings!
        </p>
        
        <p class="text-left text-body-1">
            We have great teammates making great products and
            building a great future with our business. They
            are able to share thoughts and ideas openly,
            which we believe builds deep levels of trust
            across the organization. This collective trust
            fosters an environment where constructive,
            well-mannered debate leads to truly creative 
            problem solving with multiple options! Because 
            our teammates have participated in creating the
            solution(s), they commit themselves to quality
            implementation and they hold their colleagues
            accountable to do so as well.  This dynamic
            is intentional and it helps us to win as a
            team, earn the right to future work, maintain
            a healthy business for our community and deliver
            mobility products across the globe. This makes
            our work at PSAM more than just a job ...at
            PSAM, our teams and teammates 
            <span class="font-weight-bold">Serve Society
            with Superior Quality.</span>
        </p>

        <p class="text-left farewell-text">
            Sincerely, <br/>
            <span class="signature-text">Prospira Executive Committee</span>
        </p>
    </v-container>
</template>

<script>
export default {
    name: "ExecutiveCommitteeMessage"
}
</script>

<style scoped>
.greeting-text {
    font-size: 1.5rem;
    font-weight: 400;
}

.farewell-text {
    font-weight: 400;
    font-size: 1.375rem;
}

.signature-text {
    font-family: "Brush Script MT";
}
</style>